import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { unsubscribeWaitlist } from "../utils/waitlistApi";
import { errorMessage } from "../utils/errorMessage";

/**
 * Where the unsubscribe link in a waitlist email lands.
 *
 * It waits for a click rather than unsubscribing on load: mail scanners open
 * links in emails to check them, and one that ran this page would take the
 * person off the list before they had read the email.
 */
const WaitlistUnsubscribe = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState(token ? "ready" : "invalid");
  const [message, setMessage] = useState("");

  const unsubscribe = async () => {
    setState("sending");
    try {
      await unsubscribeWaitlist(token);
      setState("done");
    } catch (err) {
      setMessage(errorMessage(err, "We couldn't do that just now. Please try again in a moment."));
      setState("failed");
    }
  };

  return (
    <div className="notfound-page">
      <main className="notfound-main" aria-live="polite">
        {(state === "ready" || state === "sending") && (
          <>
            <h1>Stop waitlist emails?</h1>
            <p>We'll delete your email address from the Youro waitlist and won't email you about availability again.</p>
            <div className="notfound-actions">
              <button type="button" className="btn-filled" onClick={unsubscribe} disabled={state === "sending"}>
                {state === "sending" ? "Unsubscribing…" : "Unsubscribe"}
              </button>
            </div>
          </>
        )}
        {state === "done" && (
          <>
            <h1>You're unsubscribed</h1>
            <p>Your email address has been removed from the waitlist. You won't get any more emails from it.</p>
            <div className="notfound-actions">
              <Link className="notfound-secondary" to="/">Go to the Youro homepage</Link>
            </div>
          </>
        )}
        {state === "failed" && (
          <>
            <h1>We couldn't unsubscribe you</h1>
            <p>{message}</p>
            <div className="notfound-actions">
              <button type="button" className="btn-filled" onClick={unsubscribe}>Try again</button>
            </div>
          </>
        )}
        {state === "invalid" && (
          <>
            <h1>This link is incomplete</h1>
            <p>Open the unsubscribe link again from the email we sent you, or contact us at support@yourohealth.com.</p>
          </>
        )}
      </main>
    </div>
  );
};

export default WaitlistUnsubscribe;
